module.exports = __webpack_public_path__ + "img/star.b3cef934.svg";